@if (errorDialog.data(); as data) {
  <div
    class="fixed inset-0 bg-ink/40 z-50 flex items-center justify-center p-4"
    data-overlay="true"
    (click)="onOverlayClick($event)"
  >
    <div class="bg-white rounded-lg border border-border shadow-lg w-full max-w-sm">

      <!-- Header -->
      <div class="flex items-start justify-between p-5 pb-0">
        <div class="flex items-center gap-3">
          <div class="w-9 h-9 rounded-full bg-[#FDE8E9] flex items-center justify-center shrink-0">
            <i class="pi pi-exclamation-triangle text-danger text-base"></i>
          </div>
          <h2 class="text-[15px] font-semibold text-ink leading-[1.3]">{{ 'errorDialog.title' | translate }}</h2>
        </div>
        <button
          type="button"
          (click)="close()"
          class="w-7 h-7 flex items-center justify-center rounded-md text-muted hover:text-ink hover:bg-surface transition-colors duration-[160ms] shrink-0 ml-2"
          [attr.aria-label]="'errorDialog.close' | translate"
        >
          <i class="pi pi-times text-sm"></i>
        </button>
      </div>

      <!-- Body -->
      <div class="px-5 py-4">
        <p class="text-sm text-ink leading-[1.6]">{{ data.message }}</p>

        @if (data.correlationId) {
          <div class="mt-3">
            <button
              type="button"
              (click)="showDetails.set(!showDetails())"
              class="text-[11px] font-semibold text-muted hover:text-ink border border-border rounded px-1.5 py-0.5 transition-colors duration-[160ms]"
            >
              {{ showDetails() ? ('errorDialog.hideDetails' | translate) : ('errorDialog.showDetails' | translate) }}
            </button>
            @if (showDetails()) {
              <p class="text-[11px] text-muted font-mono break-all mt-2">{{ data.correlationId }}</p>
            }
          </div>
        }
      </div>

      <!-- Footer -->
      <div class="px-5 pb-5">
        <button
          type="button"
          (click)="close()"
          class="w-full h-10 rounded-[10px] bg-primary-500 hover:bg-primary-600 active:bg-primary-700 text-white font-semibold text-sm transition-colors duration-[160ms] flex items-center justify-center"
        >
          {{ 'errorDialog.close' | translate }}
        </button>
      </div>

    </div>
  </div>
}
